import { Routes } from '@angular/router';

import { CamMainRoute, CamRoutes } from '@camelot/menu';
import { LayoutNotFoundComponent } from '@camelot/ui';
import { AuthGuard } from '@camelot/user';

import { environment } from 'src/environments/environment';

import { UnauthenticatedAzureGuard } from './auth/unauthenticated-azure.guard';
import { NotificationsPage } from './features/base/notifications/notifications.component';
import { RedirectPage } from './features/base/redirect/redirect.component';
import { EBillingsRoute, billingsRoutes } from './features/billings/billings.routes';
import { EBillingsVisitorRoute, visitorBillingsRoutes } from './features/billings/visitor-billings.routes';
import { ECmsRoute, cmsRoutes } from './features/cms/cms.routes';
import { HomeGuard } from './features/dashboard/home.guard';
import { HomePage } from './features/dashboard/pages/home/home.component';
import { EProjectsRoute, projectsRoutes } from './features/projects/projects.routes';
import { ETicketingRoute, ticketingRoutes } from './features/ticketing/ticketing.routes';
import { LoginPage } from './features/user/pages/login/login.component';
import { EUserRoute, userRoutes } from './features/user/user.routes';

export const routes: Routes = [
  {
    path: '',
    component: HomePage,
    canActivate: [AuthGuard, HomeGuard],
  },
  {
    path: 'notifications',
    component: NotificationsPage,
    canActivate: [AuthGuard],
  },
  {
    path: 'redirect',
    component: RedirectPage,
  },
  {
    path: CamRoutes.getUrl([EProjectsRoute.projects]),
    children: projectsRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([EBillingsRoute.billing]),
    children: billingsRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([EUserRoute.myProfile]),
    children: userRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([ECmsRoute.cms]),
    children: cmsRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([ETicketingRoute.ticketing]),
    children: ticketingRoutes,
    canActivate: [AuthGuard],
  },
  {
    path: CamRoutes.getUrl([CamMainRoute.USERLOGIN]),
    component: LoginPage,
    canActivate: [UnauthenticatedAzureGuard],
  },
  {
    // B2C redirect target after login or signup.
    path: environment.AADB2C.redirectUri.substring(1),
    redirectTo: '',
  },
  {
    path: CamRoutes.getUrl([EBillingsVisitorRoute.billing]),
    children: visitorBillingsRoutes,
  },
  /** e2e only — lazy, and emptied by fileReplacements in the production build */
  {
    path: 'e2e-harness',
    loadChildren: () => import('./e2e.routes').then(m => m.e2eRoutes),
  },
  {
    path: 'e2e-guarded',
    loadComponent: () => import('@camelot/testing-harness').then(m => m.HarnessComponent),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: LayoutNotFoundComponent,
  },
];
